<script>
export default {
  name: 'VNode',

  props: {
    vnode: {
      type: Object,
      required: true,
    },
  },

  render() {
    return this.vnode ? this.vnode : '';
  },
};
</script>
